import React from 'react';
import PropTypes from 'prop-types';

import { IntlManager } from '@atlas/core';
import { Icon } from '@atlas/ui';

import { CDN_TYPE_BASE, imageUrlCDN } from 'common/utils';

const AlternativeMethodItem = ({ method, onClick }) => {
  const imageStyle = method.desktopImageLink
    ? { backgroundImage: `url(${imageUrlCDN(method.desktopImageLink, CDN_TYPE_BASE)})` }
    : {};

  const hasLimits = method.minAmount && method.maxAmount;

  return (
    <button className="alternative-methods-popup__item" onClick={onClick} type="button">
      <div className="alternative-methods-popup__icon" style={imageStyle}>
        {!method.desktopImageLink && <Icon name="money" />}
      </div>
      <div className="alternative-methods-popup__info">
        <span className="alternative-methods-popup__name">{method.name}</span>
        {hasLimits && (
          <span className="alternative-methods-popup__limits">
            {`${IntlManager.formatMoney(method.minAmount)} - ${IntlManager.formatMoney(method.maxAmount)}`}
          </span>
        )}
      </div>
      <Icon className="alternative-methods-popup__arrow" name="arrow-right" />
    </button>
  );
};

AlternativeMethodItem.propTypes = {
  method: PropTypes.shape({
    desktopImageLink: PropTypes.string,
    id: PropTypes.number.isRequired,
    maxAmount: PropTypes.number,
    minAmount: PropTypes.number,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AlternativeMethodItem;
